import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import useStyle from './style';
const Scrollbar = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, trigger = 'hover', xScrollable, yScrollable = true, className, style, children, } = props;
    const { getPrefixCls, direction } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('scrollbar', customizePrefixCls);
    // Style
    const [wrapSSR, hashId] = useStyle(prefixCls);
    const cls = classNames(prefixCls, {
        [`${prefixCls}-trigger-hover`]: trigger === 'hover',
        [`${prefixCls}-trigger-rtl`]: direction === 'rtl',
        [`${prefixCls}-x-scroll`]: xScrollable,
        [`${prefixCls}-y-scroll`]: yScrollable,
    }, className, hashId);
    return wrapSSR(React.createElement("div", { ref: ref, className: cls, style: style }, children));
});
if (process.env.NODE_ENV !== 'production') {
    Scrollbar.displayName = 'Scrollbar';
}
export default Scrollbar;
